import React from 'react';
import { BellIcon, XMarkIcon } from '@heroicons/react/20/solid';
import './notifications.css';

// The small reminder shown once the sheet has been put away. It sits in the
// page flow (not fixed), so it never covers content or the top nav.
export default function NotificationOffBar({ onTurnOn, onHide, turnOnRef }) {
  return (
    <div className="notif-bar">
      <BellIcon className="notif-bar__icon" width="20" height="20" aria-hidden="true" />
      <span className="notif-bar__text">Notifications are off</span>
      <button type="button" ref={turnOnRef} className="notif-bar__on" onClick={onTurnOn}>Turn on</button>
      <button type="button" className="notif-bar__close" aria-label="Hide for 30 days" onClick={onHide}>
        <XMarkIcon width="18" height="18" aria-hidden="true" />
      </button>
    </div>
  );
}
